import ApVideoPlayer from "./ApVideoHub";

window.nextologies = window.nextologies
    ? {
        ...window.nextologies,
        player: ApVideoPlayer
    }
    : {
        player: ApVideoPlayer
    };

export const player = ApVideoPlayer;
